export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrowDownDark.e02572dd.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};